/*
FILE:           constants.js
AUTHOR:         Timothy Thai
CREATED:        31/08/2026
LAST UPDATED:   24/09/2026
PURPOSE:        Provide global constants for the website
*/

export const EFFECTIVE_DATE = '26 June 2026';
export const COMPANY_NAME = 'custum.ai';
export const COMPANY_LEGAL = 'The Trustee for The Shataz Trust';
export const COMPANY_ABN = '68 629 156 933';
export const CONTACT_EMAIL = 'info@custum.ai';
export const CONTACT_PHONE = '+61 485 019 781';
export const ADDRESS = 'Suite 3, 16 Brodie-Hall Drive, Bentley, WA, 6102';
export const CALLS_HANDLED = 5250;
export const HOURS_SAVED = 400;
export const PRODUCTS = [
  {
    image: '/img/products/aisa.webp',
    tag: 'AISA',
    title: 'AI Sales Assistant',
    desc: 'A natural-sounding AI voice agent that handles inbound and outbound calls — qualifying leads, completing workflows, and escalating to your team only when it matters.',
    bullets: ['Inbound & outbound calls', 'Smart transfer & escalation', 'Transcripts & analytics'],
  },
  {
    image: '/img/products/aice.webp',
    tag: 'AICE',
    title: 'AI Customer Excellence',
    desc: 'Your business never misses a call. Books appointments, captures leads, and routes enquiries 24 hours a day, seven days a week.',
    bullets: ['24/7 call answering', 'Appointment booking & scheduling', 'Lead capture & CRM sync'],
  },
  {
    image: '/img/products/aic.webp',
    tag: 'AIC',
    title: 'AI Chatbot',
    desc: 'An intelligent chatbot trained on your knowledge base. Answers questions, qualifies visitors, and hands off to your team with full conversation context.',
    bullets: ['Knowledge-base trained responses', 'Lead capture & qualification', 'Live agent handoff'],
  },
  {
    image: '/img/products/aims.webp',
    tag: 'AIMS',
    title: 'AI Messaging Service',
    desc: 'An intelligent messaging agent that can receive and send messages on your behalf.',
    bullets: ['Lead capture & qualification', 'Live agent handoff'],
  },
  {
    image: '/img/products/automation.webp',
    tag: 'AUTOMATION',
    title: 'Automation & Systems',
    desc: 'We connect your AI to the systems you already run your business on — and build the ones you don’t have yet. CRMs, integrations, workflows, and notifications, all working together.',
    bullets: ['Connects to your existing systems', 'New CRMs, integrations & workflows built for you', 'Automated notifications & handoffs'],
  }
];